import React from 'react';
import { bool, string } from 'prop-types';
import { Box, SvgIcon, Typography } from '@mui/material';
import DotIcon from 'assets/icons/dot.svg';

const GeneralInfo = ({
  className = '',
  name,
  code = '',
  jobTitle = '',
  department = '',
  isApp,
}) => (
  <Box className={className} sx={{ paddingBottom: '10px' }}>
    <Typography
      sx={{
        fontSize: 28,
        fontWeight: 'bold',
        color: 'primary.ultraDark',
        textTransform: 'capitalize',
      }}
    >
      {name}{' '}
      {isApp ? (
        <Box
          component="span"
          sx={{
            fontSize: '0.5em',
            p: '0 4px',
            backgroundColor: 'secondary.light',
            borderRadius: '4px',
          }}
        >
          App
        </Box>
      ) : null}
    </Typography>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        color: 'text.primary',
        textTransform: 'capitalize',
      }}
    >
      {code}{' '}
      <SvgIcon sx={{ fontSize: 4, marginRight: '10px', marginLeft: '10px' }}>
        <DotIcon />
      </SvgIcon>
      {jobTitle}{' '}
      <SvgIcon sx={{ fontSize: 4, marginRight: '10px', marginLeft: '10px' }}>
        <DotIcon />
      </SvgIcon>{' '}
      {department}
    </Box>
  </Box>
);
GeneralInfo.propTypes = {
  isApp: bool.isRequired,
  className: string,
  name: string.isRequired,
  jobTitle: string,
  department: string,
  code: string,
};

export default GeneralInfo;
